import female2 from "./female2.png";
import female3 from "./female3.png";
import female4 from "./female4.png";
import male1 from "./male1.png";
import male2 from "./male2.png";
import male3 from "./male3.png";
import male4 from "./male4.png";
import female1 from "./female1.png";
import casinoFemale1 from "./casinoFemale1.png";
import casinoFemale2 from "./casinoFemale2.png";
import casinoMale1 from "./casinoMale1.png";
import casinoMale2 from "./casinoMale2.png";
import dubaiFemale from "./dubaiFemale.png";
import dubaiMale from "./dubaiMale.png";
import rpmBeigeJacketMale from "./RPM_BeigeJacket_Male.png";
import rpmBlackBomberThirdEyeGlassesMale from "./RPM_BlackBomberThirdEyeGlasses_Male.png";
import rpmBlackButtonDownMale from "./RPM_BlackButtonDown_Male.png";
import rpmBlackCoatBlackGlovesFemale from "./RPM_BlackCoatBlackGloves_Female.png";
import rpmBlackCrossoverShirtPurpleHairMale from "./RPM_BlackCrossoverShirtPurpleHair_Male.png";
import rpmBlackJacketBucklesMale from "./RPM_BlackJacketBuckles_Male.png";
import rpmBlackJumperRedBagMale from "./RPM_BlackJumperRedBag_Male.png";
import rpmBlackLeatherSuitFemale from "./RPM_BlackLeatherSuit_Female.png";
import rpmBlueButtonDownFemale from "./RPM_BlueButtonDown_Female.png";
import rpmBlueMonsterSuitMale from "./RPM_BlueMonsterSuit_Male.png";
import rpmBlueOxfordMale from "./RPM_BlueOxford_Male.png";
import rpmBluePromSuitMale from "./RPM_BluePromSuit_Male.png";
import rpmBlueSuitMale from "./RPM_BlueSuit_Male.png";
import rpmBrownJumpsuitMale from "./RPM_BrownJumpsuit_Male.png";
import rpmCargoVestFemale from "./RPM_CargoVest_Female.png";
import rpmCheckeredShirtFemale from "./RPM_CheckeredShirt_Female.png";
import rpmDrowRangerFemale from "./RPM_DrowRanger_Female.png";
import rpmFloralSeafoamGreenJacketMale from "./RPM_FloralSeafoamGreenJacket_Male.png";
import rpmGoldBomberMale from "./RPM_GoldBomber_Male.png";
import rpmGraffitiHoodieMale from "./RPM_GraffitiHoodie_Male.png";
import rpmGreenCheckeredFemale from "./RPM_GreenCheckered_Female.png";
import rpmGreenDressFemale from "./RPM_GreenDress_Female.png";
import rpmGreenMechFemale from "./RPM_GreenMech_Female.png";
import rpmGreenPajamasMale from "./RPM_GreenPajamas_Male.png";
import rpmGreenShirtBackpackMale from "./RPM_GreenShirtBackpack_Male.png";
import rpmGreyHoodieMale from "./RPM_GreyHoodie_Male.png";
import rpmGreyJacketBlueGlovesFemale from "./RPM_GreyJacketBlueGloves_Female.png";
import rpmGreySuitMale from "./RPM_GreySuit_Male.png";
import rpmIronArmorBracerMale from "./RPM_IronArmorBracer_Male.png";
import rpmJeanJacketSpikesFemale from "./RPM_JeanJacketSpikes_Female.png";
import rpmLeatherJacketLongMale from "./RPM_LeatherJacketLong_Male.png";
import rpmLizardFemale from "./RPM_Lizard_Female.png";
import rpmPastelPinkBows from "./RPM_PastelPinkBows.png";
import rpmPinkDressFemale from "./RPM_PinkDress_Female.png";
import rpmPlainWhiteTeeFemale from "./RPM_PlainWhiteTee_Female.png";
import rpmPurpleBearFemale from "./RPM_PurpleBear_Female.png";
import rpmPurpleHairPurpleJacketMale from "./RPM_PurpleHairPurpleJacket_Male.png";
import rpmPurplePeacoatFemale from "./RPM_PurplePeacoat_Female.png";
import rpmRaceCarDriverFemale from "./RPM_RaceCarDriver_Female.png";
import rpmRedActionSuitMale from "./RPM_RedActionSuit_Male.png";
import rpmRedBlueMechanicShirtMale from "./RPM_RedBlueMechanicShirt_Male.png";
import rpmRedJacketFemale from "./RPM_RedJacket_Female.png";
import rpmSpeedShirtFemale from "./RPM_SpeedShirt_Female.png";
import rpmTieDyeMale from "./RPM_TieDye_Male.png";
import rpmTigerPrintFemale from "./RPM_TigerPrint_Female.png";
import rpmVikingAngelFemale from "./RPM_VikingAngel_Female.png";
import rpmWatermelonVestFemale from "./RPM_WatermelonVest_Female.png";
import rpmWhiteButtonDownMale from "./RPM_WhiteButtonDown_Male.png";
import rpmYellowHoodieFemale from "./RPM_YellowHoodie_Female.png";
import rpmYellowPolkaDotFemale from "./RPM_YellowPolkaDot_Female.png";
// fullbody (new) - same folder but /fullbody/
import fullRPMBeigeJacketMale from "./fullbody/RPM_BeigeJacket_Male_Icon_Full.png";
import fullRPMBlackBomberThirdEyeGlassesMale from "./fullbody/RPM_BlackBomberThirdEyeGlasses_Male_Icon_Full.png";
import fullRPMBlackButtonDownMale from "./fullbody/RPM_BlackButtonDown_Male_Icon_Full.png";
import fullRPMBlackCoatBlackGlovesFemale from "./fullbody/RPM_BlackCoatBlackGloves_Female_Icon_Full.png";
import fullRPMBlackCrossoverShirtPurpleHairMale from "./fullbody/RPM_BlackCrossoverShirtPurpleHair_Male_Icon_Full.png";
import fullRPMBlackJacketBucklesMale from "./fullbody/RPM_BlackJacketBuckles_Male_Icon_Full.png";
import fullRPMBlackJumperRedBagMale from "./fullbody/RPM_BlackJumperRedBag_Male_Icon_Full.png";
import fullRPMBlackLeatherSuitFemale from "./fullbody/RPM_BlackLeatherSuit_Female_Icon_Full.png";
import fullRPMBlueButtonDownFemale from "./fullbody/RPM_BlueButtonDown_Female_Icon_Full.png";
import fullRPMBlueMonsterSuitMale from "./fullbody/RPM_BlueMonsterSuit_Male_Icon_Full.png";
import fullRPMBlueOxfordMale from "./fullbody/RPM_BlueOxford_Male_Icon_Full.png";
import fullRPMBluePromSuitMale from "./fullbody/RPM_BluePromSuit_Male_Icon_Full.png";
import fullRPMBlueSuitMale from "./fullbody/RPM_BlueSuit_Male_Icon_Full.png";
import fullRPMBrownJumpsuitMale from "./fullbody/RPM_BrownJumpsuit_Male_Icon_Full.png";
import fullRPMCargoVestFemale from "./fullbody/RPM_CargoVest_Female_Icon_Full.png";
import fullRPMCheckeredShirtFemale from "./fullbody/RPM_CheckeredShirt_Female_Icon_Full.png";
import fullRPMDrowRangerFemale from "./fullbody/RPM_DrowRanger_Female_Icon_Full.png";
import fullRPMGoldBomberMale from "./fullbody/RPM_GoldBomber_Male_Icon_Full.png";
import fullRPMGreenCheckeredFemale from "./fullbody/RPM_GreenCheckered_Female_Icon_Full.png";
import fullRPMGreenDressFemale from "./fullbody/RPM_GreenDress_Female_Icon_Full.png";
import fullRPMGreenMechFemale from "./fullbody/RPM_GreenMech_Female_Icon_Full.png";
import fullRPMGreenPajamasMale from "./fullbody/RPM_GreenPajamas_Male_Icon_Full.png";
import fullRPMGreenShirtBackpackMale from "./fullbody/RPM_GreenShirtBackpack_Male_Icon_Full.png";
import fullRPMGrryHoodieMale from "./fullbody/RPM_GreyHoodie_Male_Icon_Full.png";
import fullRPMGrryJacketBlueGlovesFemale from "./fullbody/RPM_GreyJacketBlueGloves_Female_Icon_Full.png";
import fullRPMGrrySuitMale from "./fullbody/RPM_GreySuit_Male_Icon_Full.png";
import fullRPMIronArmorBracerMale from "./fullbody/RPM_IronArmorBracer_Male_Icon_Full.png";
import fullRPMJeanJacketSpikesFemale from "./fullbody/RPM_JeanJacketSpikes_Female_Icon_Full.png";
import fullRPMLeatherJacketLongMale from "./fullbody/RPM_LeatherJacketLong_Male_Icon_Full.png";
import fullRPMLizardFemale from "./fullbody/RPM_Lizard_Female_Icon_Full.png";
import fullRPMPastelPinkBows from "./fullbody/RPM_PastelPinkBows_Icon_Full.png";
import fullRPMPinkDressFemale from "./fullbody/RPM_PinkDress_Female_Icon_Full.png";
import fullRPMPlainWhiteTeeFemale from "./fullbody/RPM_PlainWhiteTee_Female_Icon_Full.png";
import fullRPMPurpleBearFemale from "./fullbody/RPM_PurpleBear_Female_Icon_Full.png";
import fullRPMPurpleHairPurpleJacketMale from "./fullbody/RPM_PurpleHairPurpleJacket_Male_Icon_Full.png";
import fullRPMPurplePeacoatFemale from "./fullbody/RPM_PurplePeacoat_Female_Icon_Full.png";
import fullRPMRaceCarDriverFemale from "./fullbody/RPM_RaceCarDriver_Female_Icon_Full.png";
import fullRPMRedActionSuitMale from "./fullbody/RPM_RedActionSuit_Male_Icon_Full.png";
import fullRPMRedBlueMechanicShirtMale from "./fullbody/RPM_RedBlueMechanicShirt_Male_Icon_Full.png";
import fullRPMRedJacketFemale from "./fullbody/RPM_RedJacket_Female_Icon_Full.png";
import fullRPMSpeedShirtFemale from "./fullbody/RPM_SpeedShirt_Female_Icon_Full.png";
import fullRPMTieDyeMale from "./fullbody/RPM_TieDye_Male_Icon_Full.png";
import fullRPMTigerPrintFemale from "./fullbody/RPM_TigerPrint_Female_Icon_Full.png";
import fullRPMVikingAngelFemale from "./fullbody/RPM_VikingAngel_Female_Icon_Full.png";
import fullRPMWatermelonVestFemale from "./fullbody/RPM_WatermelonVest_Female_Icon_Full.png";
import fullRPMWhiteButtonDownMale from "./fullbody/RPM_WhiteButtonDown_Male_Icon_Full.png";
import fullRPMYellowHoodieFemale from "./fullbody/RPM_YellowHoodie_Female_Icon_Full.png";
import fullRPMYellowPolkaDotFemale from "./fullbody/RPM_YellowPolkaDot_Female_Icon_Full.png";
import fullRPMFloralSeafoamGreenJacketMale from "./fullbody/RPM_SeafoamGreenJacket_Male_Icon_Full.png";
import fullRPMGraffitiHoodieMale from "./fullbody/RPM_GraffitiHoodie_Male_Icon_Full.png";

const avatars = [
    // non-RPM base
    // {
    //     name: "female2",
    //     avatarDatabaseId: "932323ed-b32f-4133-874c-e456623ac8e1",
    //     image: female2,
    //     fullbody: female2,
    //     id: 0,
    // },
    // { name: "male4", avatarDatabaseId: "93feaa59-a96d-4c3d-a7aa-6ea5f04d92aa", image: male4, fullbody: male4, id: 1 },
    // {
    //     name: "female4",
    //     avatarDatabaseId: "93feaa59-a96d-4c3d-a7aa-6ea5f04d92bb",
    //     image: female4,
    //     fullbody: female4,
    //     id: 2,
    // },
    // { name: "male1", avatarDatabaseId: "93feaa59-a96d-4c3d-a7aa-6ea5f04d92cb", image: male1, fullbody: male1, id: 3 },
    // {
    //     name: "female1",
    //     avatarDatabaseId: "93feaa59-a96d-4c3d-a7aa-6ea5f04d92dd",
    //     image: female1,
    //     fullbody: female1,
    //     id: 4,
    // },
    // { name: "male3", avatarDatabaseId: "93feaa59-a96d-4c3d-a7aa-6ea5f04d92ff", image: male3, fullbody: male3, id: 5 },
    // {
    //     name: "female3",
    //     avatarDatabaseId: "93feaa59-a96d-4c3d-a7aa-6ea5f04d92ac",
    //     image: female3,
    //     fullbody: female3,
    //     id: 6,
    // },
    // { name: "male2", avatarDatabaseId: "93feaa59-a96d-4c3d-a7aa-6ea5f04d92ed", image: male2, fullbody: male2, id: 7 },

    // RPM avatars
    {
        name: "RPM_BeigeJacket_Male",
        avatarDatabaseId: "c66e3049-be37-46db-ae83-ae72de77bef4",
        image: rpmBeigeJacketMale,
        fullbody: fullRPMBeigeJacketMale,
        id: 8,
    },
    {
        name: "RPM_BlackBomberThirdEyeGlasses_Male",
        avatarDatabaseId: "d8f7d294-8caf-4d83-b1f1-ef6a87f9e10a",
        image: rpmBlackBomberThirdEyeGlassesMale,
        fullbody: fullRPMBlackBomberThirdEyeGlassesMale,
        id: 9,
    },
    {
        name: "RPM_BlackButtonDown_Male",
        avatarDatabaseId: "89a8b6c3-cc6f-4554-89b1-de0d462a2a56",
        image: rpmBlackButtonDownMale,
        fullbody: fullRPMBlackButtonDownMale,
        id: 10,
    },
    {
        name: "RPM_BlackCoatBlackGloves_Female",
        avatarDatabaseId: "70496700-bea4-4bec-8a5c-0b32348d0962",
        image: rpmBlackCoatBlackGlovesFemale,
        fullbody: fullRPMBlackCoatBlackGlovesFemale,
        id: 11,
    },
    {
        name: "RPM_BlackCrossoverShirtPurpleHair_Male",
        avatarDatabaseId: "ee58cab8-22a6-4749-8b4a-049a0a718677",
        image: rpmBlackCrossoverShirtPurpleHairMale,
        fullbody: fullRPMBlackCrossoverShirtPurpleHairMale,
        id: 12,
    },
    {
        name: "RPM_BlackJacketBuckles_Male",
        avatarDatabaseId: "550771a2-db2d-41ca-b461-652f0a570b78",
        image: rpmBlackJacketBucklesMale,
        fullbody: fullRPMBlackJacketBucklesMale,
        id: 13,
    },
    {
        name: "RPM_BlackJumperRedBag_Male",
        avatarDatabaseId: "787073b6-f941-428b-a02c-16f24d310ae6",
        image: rpmBlackJumperRedBagMale,
        fullbody: fullRPMBlackJumperRedBagMale,
        id: 14,
    },
    {
        name: "RPM_BlackLeatherSuit_Female",
        avatarDatabaseId: "aa0fd024-f166-4ed6-a0cf-a8cc5c55bab3",
        image: rpmBlackLeatherSuitFemale,
        fullbody: fullRPMBlackLeatherSuitFemale,
        id: 15,
    },
    {
        name: "RPM_BlueButtonDown_Female",
        avatarDatabaseId: "7cea7320-af1e-4399-97fd-a363d0a37010",
        image: rpmBlueButtonDownFemale,
        fullbody: fullRPMBlueButtonDownFemale,
        id: 16,
    },
    {
        name: "RPM_BlueMonsterSuit_Male",
        avatarDatabaseId: "82081764-d933-4fa9-a659-07a63e9e37c0",
        image: rpmBlueMonsterSuitMale,
        fullbody: fullRPMBlueMonsterSuitMale,
        id: 17,
    },
    {
        name: "RPM_BlueOxford_Male",
        avatarDatabaseId: "860d0af0-37fc-4ceb-b33a-4e78b8c2ed29",
        image: rpmBlueOxfordMale,
        fullbody: fullRPMBlueOxfordMale,
        id: 18,
    },
    {
        name: "RPM_BluePromSuit_Male",
        avatarDatabaseId: "cc7f6d26-7ac9-4716-8949-229419cef6e8",
        image: rpmBluePromSuitMale,
        fullbody: fullRPMBluePromSuitMale,
        id: 19,
    },
    {
        name: "RPM_BlueSuit_Male",
        avatarDatabaseId: "30862201-d06a-49ae-b50c-d5ae9b9f6244",
        image: rpmBlueSuitMale,
        fullbody: fullRPMBlueSuitMale,
        id: 20,
    },
    {
        name: "RPM_BrownJumpsuit_Male",
        avatarDatabaseId: "c154a2a8-c905-49b4-8ac8-9fc1e051504f",
        image: rpmBrownJumpsuitMale,
        fullbody: fullRPMBrownJumpsuitMale,
        id: 21,
    },
    {
        name: "RPM_CargoVest_Female",
        avatarDatabaseId: "1dc5af78-8153-47d2-b802-017a298ba332",
        image: rpmCargoVestFemale,
        fullbody: fullRPMCargoVestFemale,
        id: 22,
    },
    {
        name: "RPM_CheckeredShirt_Female",
        avatarDatabaseId: "ba69c7e8-0717-4347-9d40-dbeb9de1f3cf",
        image: rpmCheckeredShirtFemale,
        fullbody: fullRPMCheckeredShirtFemale,
        id: 23,
    },
    {
        name: "RPM_DrowRanger_Female",
        avatarDatabaseId: "96a670a5-453a-4aad-830d-db41c5bd7015",
        image: rpmDrowRangerFemale,
        fullbody: fullRPMDrowRangerFemale,
        id: 24,
    },
    {
        name: "RPM_FloralSeafoamGreenJacket_Male",
        avatarDatabaseId: "0d685afd-b820-477c-b60f-0910d50544d0",
        image: rpmFloralSeafoamGreenJacketMale,
        fullbody: fullRPMFloralSeafoamGreenJacketMale,
        id: 25,
    },
    {
        name: "RPM_GoldBomber_Male",
        avatarDatabaseId: "cc75f999-e6a1-417f-bfe6-ac1ca8cf349c",
        image: rpmGoldBomberMale,
        fullbody: fullRPMGoldBomberMale,
        id: 26,
    },
    {
        name: "RPM_GraffitiHoodie_Male",
        avatarDatabaseId: "58aa0203-80e7-4a86-bb36-93974de4a63f",
        image: rpmGraffitiHoodieMale,
        fullbody: fullRPMGraffitiHoodieMale,
        id: 27,
    },
    {
        name: "RPM_GreenCheckered_Female",
        avatarDatabaseId: "f73c6351-82df-42af-bde1-79e5a9f9418e",
        image: rpmGreenCheckeredFemale,
        fullbody: fullRPMGreenCheckeredFemale,
        id: 28,
    },
    {
        name: "RPM_GreenDress_Female",
        avatarDatabaseId: "27129146-318c-4b46-9eb8-91dd78615c2d",
        image: rpmGreenDressFemale,
        fullbody: fullRPMGreenDressFemale,
        id: 29,
    },
    {
        name: "RPM_GreenMech_Female",
        avatarDatabaseId: "09caea01-7df5-4954-bdad-d8bddedb0c2b",
        image: rpmGreenMechFemale,
        fullbody: fullRPMGreenMechFemale,
        id: 30,
    },
    {
        name: "RPM_GreenPajamas_Male",
        avatarDatabaseId: "876e35cd-aa62-4123-931a-0bdc07cc3fd1",
        image: rpmGreenPajamasMale,
        fullbody: fullRPMGreenPajamasMale,
        id: 31,
    },
    {
        name: "RPM_GreenShirtBackpack_Male",
        avatarDatabaseId: "064fbbd9-72a9-480e-a710-c511d867e270",
        image: rpmGreenShirtBackpackMale,
        fullbody: fullRPMGreenShirtBackpackMale,
        id: 32,
    },
    {
        name: "RPM_GreyHoodie_Male",
        avatarDatabaseId: "72eb688b-9191-4e3a-8300-5a4b652d991a",
        image: rpmGreyHoodieMale,
        fullbody: fullRPMGrryHoodieMale,
        id: 33,
    },
    {
        name: "RPM_GreyJacketBlueGloves_Female",
        avatarDatabaseId: "ee1e29df-a948-456a-a7ac-663b708fbda3",
        image: rpmGreyJacketBlueGlovesFemale,
        fullbody: fullRPMGrryJacketBlueGlovesFemale,
        id: 34,
    },
    {
        name: "RPM_GreySuit_Male",
        avatarDatabaseId: "03a641dc-61d6-4949-a2d8-260520b62a95",
        image: rpmGreySuitMale,
        fullbody: fullRPMGrrySuitMale,
        id: 35,
    },
    {
        name: "RPM_IronArmorBracer_Male",
        avatarDatabaseId: "9c553d26-507b-4efe-9282-d2c34f63fd55",
        image: rpmIronArmorBracerMale,
        fullbody: fullRPMIronArmorBracerMale,
        id: 36,
    },
    {
        name: "RPM_JeanJacketSpikes_Female",
        avatarDatabaseId: "76d78359-70d8-43df-a75c-82b029761674",
        image: rpmJeanJacketSpikesFemale,
        fullbody: fullRPMJeanJacketSpikesFemale,
        id: 37,
    },
    {
        name: "RPM_LeatherJacketLong_Male",
        avatarDatabaseId: "6f64c5da-c0c1-43db-aa24-54d0ecb04ec4",
        image: rpmLeatherJacketLongMale,
        fullbody: fullRPMLeatherJacketLongMale,
        id: 38,
    },
    {
        name: "RPM_Lizard_Female",
        avatarDatabaseId: "d933f8dd-42f4-4a28-a1e0-bf8025f55211",
        image: rpmLizardFemale,
        fullbody: fullRPMLizardFemale,
        id: 39,
    },
    {
        name: "RPM_PastelPinkBows",
        avatarDatabaseId: "32fd0ae8-0a72-49a3-967d-df7172a9aca7",
        image: rpmPastelPinkBows,
        fullbody: fullRPMPastelPinkBows,
        id: 40,
    },
    {
        name: "RPM_PinkDress_Female",
        avatarDatabaseId: "10b42d52-f95f-453a-931e-02dae46de2e9",
        image: rpmPinkDressFemale,
        fullbody: fullRPMPinkDressFemale,
        id: 41,
    },
    {
        name: "RPM_PlainWhiteTee_Female",
        avatarDatabaseId: "af73d075-f5fe-46df-92c4-296a63779661",
        image: rpmPlainWhiteTeeFemale,
        fullbody: fullRPMPlainWhiteTeeFemale,
        id: 42,
    },
    {
        name: "RPM_PurpleBear_Female",
        avatarDatabaseId: "3bc9d03f-dd1c-4018-9c54-03d96e762411",
        image: rpmPurpleBearFemale,
        fullbody: fullRPMPurpleBearFemale,
        id: 43,
    },
    {
        name: "RPM_PurpleHairPurpleJacket_Male",
        avatarDatabaseId: "79ec7010-0a88-47c9-b70e-32c6f0ea8245",
        image: rpmPurpleHairPurpleJacketMale,
        fullbody: fullRPMPurpleHairPurpleJacketMale,
        id: 44,
    },
    {
        name: "RPM_PurplePeacoat_Female",
        avatarDatabaseId: "82b988ae-5bb3-4317-a6cd-d0493cf0ed4c",
        image: rpmPurplePeacoatFemale,
        fullbody: fullRPMPurplePeacoatFemale,
        id: 45,
    },
    {
        name: "RPM_RaceCarDriver_Female",
        avatarDatabaseId: "d44f4550-e2f6-4836-92e8-6071b915bc9c",
        image: rpmRaceCarDriverFemale,
        fullbody: fullRPMRaceCarDriverFemale,
        id: 46,
    },
    {
        name: "RPM_RedActionSuit_Male",
        avatarDatabaseId: "d2e5345a-738d-4522-87db-238aeb7a685f",
        image: rpmRedActionSuitMale,
        fullbody: fullRPMRedActionSuitMale,
        id: 47,
    },
    {
        name: "RPM_RedBlueMechanicShirt_Male",
        avatarDatabaseId: "d3629caf-1cc5-41fc-b388-e8408265e112",
        image: rpmRedBlueMechanicShirtMale,
        fullbody: fullRPMRedBlueMechanicShirtMale,
        id: 48,
    },
    {
        name: "RPM_RedJacket_Female",
        avatarDatabaseId: "6a028f37-8b2b-4bb9-809c-15cfc407010b",
        image: rpmRedJacketFemale,
        fullbody: fullRPMRedJacketFemale,
        id: 49,
    },
    {
        name: "RPM_SpeedShirt_Female",
        avatarDatabaseId: "7f749de3-a6de-4af0-a92a-708714b551de",
        image: rpmSpeedShirtFemale,
        fullbody: fullRPMSpeedShirtFemale,
        id: 50,
    },
    {
        name: "RPM_TieDye_Male",
        avatarDatabaseId: "87204f47-8736-4fe2-aa9f-66fb7c84eb3c",
        image: rpmTieDyeMale,
        fullbody: fullRPMTieDyeMale,
        id: 51,
    },
    {
        name: "RPM_TigerPrint_Female",
        avatarDatabaseId: "ecbf02c0-244a-4f5f-a7a3-33c6dabc2d24",
        image: rpmTigerPrintFemale,
        fullbody: fullRPMTigerPrintFemale,
        id: 52,
    },
    {
        name: "RPM_VikingAngel_Female",
        avatarDatabaseId: "b18ebeb9-e022-4cb7-af33-3bbfee474315",
        image: rpmVikingAngelFemale,
        fullbody: fullRPMVikingAngelFemale,
        id: 53,
    },
    {
        name: "RPM_WatermelonVest_Female",
        avatarDatabaseId: "169acfa4-19e4-4b4b-95e6-9179b33b65e0",
        image: rpmWatermelonVestFemale,
        fullbody: fullRPMWatermelonVestFemale,
        id: 54,
    },
    {
        name: "RPM_WhiteButtonDown_Male",
        avatarDatabaseId: "68d86b1a-fd4b-4141-bed3-68749c3e06ec",
        image: rpmWhiteButtonDownMale,
        fullbody: fullRPMWhiteButtonDownMale,
        id: 55,
    },
    {
        name: "RPM_YellowHoodie_Female",
        avatarDatabaseId: "1c6459ca-0ef7-4ad2-b84f-468d3b7ab211",
        image: rpmYellowHoodieFemale,
        fullbody: fullRPMYellowHoodieFemale,
        id: 56,
    },
    {
        name: "RPM_YellowPolkaDot_Female",
        avatarDatabaseId: "6fa83dfe-ecdb-4d56-8225-fe99ac03c2a5",
        image: rpmYellowPolkaDotFemale,
        fullbody: fullRPMYellowPolkaDotFemale,
        id: 57,
    },

    // // casino (non-RPM fullbody = image)
    // {
    //     name: "casinoFemale1",
    //     avatarDatabaseId: "6c32532f-2dfd-4503-a908-620c4943c28a",
    //     image: casinoFemale1,
    //     fullbody: casinoFemale1,
    //     id: 58,
    // },
    // {
    //     name: "casinoMale1",
    //     avatarDatabaseId: "6c32532f-2dfd-4503-a908-620c4943c28b",
    //     image: casinoMale1,
    //     fullbody: casinoMale1,
    //     id: 59,
    // },
    // {
    //     name: "casinoFemale2",
    //     avatarDatabaseId: "6c32532f-2dfd-4503-a908-620c4943c28c",
    //     image: casinoFemale2,
    //     fullbody: casinoFemale2,
    //     id: 60,
    // },
    // {
    //     name: "casinoMale2",
    //     avatarDatabaseId: "6c32532f-2dfd-4503-a908-620c4943c28d",
    //     image: casinoMale2,
    //     fullbody: casinoMale2,
    //     id: 61,
    // },

    // dubai (non-RPM fullbody = image)
    // {
    //     name: "dubaiFemale",
    //     avatarDatabaseId: "1ae257ba-eb0d-4a07-96fc-e316c1eb0d7a",
    //     image: dubaiFemale,
    //     fullbody: dubaiFemale,
    //     id: 62,
    // },
    // {
    //     name: "dubaiMale",
    //     avatarDatabaseId: "79145b9d-23b4-4d5b-8654-c8f27ecbb2c8",
    //     image: dubaiMale,
    //     fullbody: dubaiMale,
    //     id: 63,
    // },
];

export default avatars;
